import { useState } from 'react';
import React from 'react';
import { pdfjs } from 'react-pdf';
import { Document, Page } from 'react-pdf';

import { ChevronLeft, ChevronRight, X } from 'lucide-react';

import { Sheet, SheetContent, SheetTitle } from '@codes/ui-kit';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PdfViewDialog = ({
    url,
    open,
    setOpen,
}: {
    url: string;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);

    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber === numPages;

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
    }

    const pageMoveBtnTapped = (next: boolean) => {
        setPageNumber(prev => (next ? prev + 1 : prev - 1));
    };

    const onOpenChange = (open: boolean) => {
        setOpen(open);

        if (!open) {
            setPageNumber(1);
        }
    };

    const closeBtnTapped = () => {
        onOpenChange(false);
    };

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetTitle></SheetTitle>
            <SheetContent aria-describedby={undefined} className="max-sm:w-full">
                <div className="relative flex justify-center">
                    <Document file={`${url}`} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <button
                        className="absolute right-0 top-0 bg-white text-black border border-black rounded"
                        onClick={closeBtnTapped}
                    >
                        <X />
                    </button>
                    <div className="flex items-center justify-center gap-x-2 absolute  left-0 bottom-4 text-black h-10 w-full z-50">
                        <div className="px-2 h-full border bg-white flex gap-x-2 items-center border-black rounded">
                            {!isFirstPage && (
                                <button onClick={() => pageMoveBtnTapped(false)}>
                                    <ChevronLeft />
                                </button>
                            )}

                            <div className="font-bold mx-2">{pageNumber}</div>
                            {!isLastPage && (
                                <button onClick={() => pageMoveBtnTapped(true)}>
                                    <ChevronRight />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
};
